import React from "react";
import Input from "../components/Utilities/Input";
import Button from "../components/Utilities/Button";
import Check from "../../assets/svgs/Check";
import EditBtn from "../../assets/svgs/EditBtn";
import { useRootContext } from "../../context";
import { useNavigate } from "react-router-dom";

const NewCompany = () => {
  const { dispatch } = useRootContext();
  const Navigate = useNavigate();

  function doneHandler() {
    Navigate("/");
    dispatch({ type: "toggle_hiddenLeftbarWhenShowForms" });
  }
  return (
    <div
      style={{
        background:
          "linear-gradient(224.99deg, #FA4A6F -12.19%, #BA004F 68.55%), #FFFFFF",
      }}
      className="pt-5 pb-10 flex justify-center items-center text-white hue-rotate-15 w-full min-h-screen"
    >
      <div className="px-5 sm:px-0 w-full sm:w-64 md:w-72 lg:w-80 flex flex-col justify-center items-center space-y-5">
        <div className="w-16 h-16 rounded-lg bg-gray-200"></div>
        <div className="flex items-center justify-center space-x-1">
          <span>New Company</span>
          <button className="flex w-12 -mb-3 items-center">
            <EditBtn />
          </button>
        </div>
        <div className="space-y-3 w-full sm:w-auto">
          <Input placeholder="Name" />
          <Input placeholder="Contact Person" />
          <Input type="email" placeholder="Email" />
          <Input placeholder="Phone number" />
          <Input placeholder="Website url" />
        </div>
        <Button onClick={doneHandler} text="Done" />
        <button className="p-2 rounded-full bg-white text-black border-2 border-transparent focus:border-blue-500">
          <Check />
        </button>
      </div>
    </div>
  );
};

export default NewCompany;
